"use client";

import { useRouter, useSearchParams, usePathname } from "next/navigation";
import { ArrowUpDown } from "lucide-react";

export interface SortOption {
  value: string;
  label: string;
}

interface Props {
  options: SortOption[];
  defaultValue: string;
  param?: string;
}

export function SortSelect({ options, defaultValue, param = "sort" }: Props) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const value = searchParams.get(param) ?? defaultValue;

  return (
    <label className="inline-flex items-center gap-2 h-10 px-3 rounded-full border bg-card text-xs font-semibold">
      <ArrowUpDown className="w-3.5 h-3.5 text-muted-foreground" />
      <span className="text-muted-foreground hidden sm:inline">Ordenar:</span>
      <select
        value={value}
        onChange={(e) => {
          const params = new URLSearchParams(searchParams.toString());
          params.set(param, e.target.value);
          params.delete("page");
          router.replace(`${pathname}?${params.toString()}`, { scroll: false });
        }}
        className="bg-transparent text-xs font-bold focus:outline-hidden"
        aria-label="Ordenar resultados"
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
